<template>
  <div>
    <el-table
        element-loading-spinner="el-icon-loading"
        :data="parentList"
        border
        :max-height="$tableMaxHeight"
        :header-cell-style="headerCellStyle"
        :element-loading-text="$tableLoading"
        element-loading-background="rgba(255,255,255, 0)"
        v-loading="isLoading"
    >
<!--      <el-table-column-->
<!--          type="selection"-->
<!--          width="50"-->
<!--          align="center"-->
<!--      />-->

      <el-table-column
          type="index"
          label="STT"
          width="50"
          align="center"
      />

      <el-table-column
          label="Họ và tên phụ huynh"
      >
        <template v-slot:default="scope">
          <span>{{ scope.row.nameRepresentation }}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Số điện thoại"
          width="200"
      >
        <template v-slot:default="scope">
          <span>{{ scope.row.numberPhone }}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Đang học"
          width="120"
          align="center"
      >
        <template v-slot:default="scope">
          <el-tooltip>
            <div slot="content">
              <div
                  v-for="(item, index) in scope.row.kidsStudying.listKidsOfParent"
                  :key="index"
              >
                {{ item.fullName }} - {{ item.className }} - {{ item.gradeName }}
              </div>
            </div>

            <span v-if="scope.row.kidsStudying.numberKidsStatus > 0">
              {{ scope.row.kidsStudying.numberKidsStatus }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
          label="Chờ học"
          width="120"
          align="center"
      >
        <template v-slot:default="scope">
          <el-tooltip>
            <div slot="content">
              <div
                  v-for="(item, index) in scope.row.kidsWaitingToLearn.listKidsOfParent"
                  :key="index"
              >
                {{ item.fullName }} - {{ item.className }} - {{ item.gradeName }}
              </div>
            </div>

            <span v-if="scope.row.kidsWaitingToLearn.numberKidsStatus > 0">
              {{ scope.row.kidsWaitingToLearn.numberKidsStatus }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
          label="Bảo lưu"
          width="120"
          align="center"
      >
        <template v-slot:default="scope">
          <el-tooltip>
            <div slot="content">
              <div
                  v-for="(item, index) in scope.row.kidsReserve.listKidsOfParent"
                  :key="index"
              >
                {{ item.fullName }} - {{ item.className }} - {{ item.gradeName }}
              </div>
            </div>

            <span v-if="scope.row.kidsReserve.numberKidsStatus > 0">
              {{ scope.row.kidsReserve.numberKidsStatus }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
          label="Nghỉ học"
          width="120"
          align="center"
      >
        <template v-slot:default="scope">
          <el-tooltip>
            <div slot="content">
              <div
                  v-for="(item, index) in scope.row.kidsLeaveSchool.listKidsOfParent"
                  :key="index"
              >
                {{ item.fullName }} - {{ item.className }} - {{ item.gradeName }}
              </div>
            </div>

            <span v-if="scope.row.kidsLeaveSchool.numberKidsStatus > 0">
              {{ scope.row.kidsLeaveSchool.numberKidsStatus }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
          label="Ra trường"
          width="120"
          align="center"
      >
        <template v-slot:default="scope">
          <el-tooltip>
            <div slot="content">
              <div
                  v-for="(item, index) in scope.row.kidsOutSchool.listKidsOfParent"
                  :key="index"
              >
                {{ item.fullName }} - {{ item.className }} - {{ item.gradeName }}
              </div>
            </div>

            <span v-if="scope.row.kidsOutSchool.numberKidsStatus > 0">
              {{ scope.row.kidsOutSchool.numberKidsStatus }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
          label="Tổng số con"
          width="120"
          align="center"
      >
        <template v-slot:default="scope">
          <span>{{ scope.row.numberOfChildren }}</span>
        </template>
      </el-table-column>

      <!--      <el-table-column-->
      <!--          fixed="right"-->
      <!--          label="Tác vụ"-->
      <!--          width="215"-->
      <!--          align="center"-->
      <!--      >-->
      <!--        <template>-->

      <!--        </template>-->
      <!--      </el-table-column>-->

      <template #empty>
        <div style="text-align: center; font-size: 16px; color: #43a0ff;">
          <i class="el-icon-warning"></i>
          <span> Không có dữ liệu! </span>
        </div>
      </template>
    </el-table>
  </div>
</template>

<script>

import {mapState} from "vuex";
import {excelParent} from "@/services/ExcelParent";
import ParentService from "@/services/ParentService";
import {Notification} from "element-ui";

export default {
  computed: {
    ...mapState("parentStore", [
      "parentList",
      "isLoading",
      "dataExportExcel",
    ])
  },
  data() {
    return {}
  },
  methods: {
    headerCellStyle() {
      return {
        backgroundColor: "#78a5e7",
        color: "#fff",
      }
    },

    exportExcelDataParent() {
      ParentService.getDataExportExcel()
          .then((res) => {
            const data = res.data.data;
            excelParent.exportExcel(this.setDataExportExcel(data?.childrenOfParentsResponseList));
          })
          .catch((err) => {
            console.log(err);
            Notification({
              title: 'Lỗi',
              message: 'Lỗi lấy dữ liệu!',
              type: 'warning',
              duration: 3000,
            });
          });
    },

    setDataExportExcel (data) {
      return data.map((parent) => {
        const {...rest} = parent;
        const children = [
          ...(parent?.kidsStudying?.listKidsOfParent || []),
          ...(parent?.kidsWaitingToLearn?.listKidsOfParent || []),
          ...(parent?.kidsReserve?.listKidsOfParent || []),
          ...(parent?.kidsLeaveSchool?.listKidsOfParent || []),
          ...(parent?.kidsOutSchool?.listKidsOfParent || []),
        ];

        return {...rest, children};
      });
    }
  }
}
</script>

<style lang="scss" scoped>

</style>